// RxJS
// NGRX
import { select, Store } from '@ngrx/store';

// State
import { AppState } from '../../../core/reducers';
// CRUD
import { BaseDataSource, QueryResultsModel } from '../../_base/crud';
import {
  selectLiquidationPageLoading,
  selectLiquidationShowInitWaitingMessage,
  selectLiquidationsInStore,
} from '../_selectors/liquidation.selectors';

export class LiquidationDataSource extends BaseDataSource {
  constructor(private store: Store<AppState>) {
    super();

    this.loading$ = this.store.pipe(select(selectLiquidationPageLoading));

    this.isPreloadTextViewed$ = this.store.pipe(
      select(selectLiquidationShowInitWaitingMessage)
    );

    this.store
      .pipe(select(selectLiquidationsInStore))
      .subscribe((response: QueryResultsModel) => {
        this.paginatorTotalSubject.next(response.totalCount);
        this.entitySubject.next(response.items);
      });
  }
}
